import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import { ADD_IDP, DELETE_IDP, FETCH_SAML_IDP_CONFIG, UPDATE_IDP } from './actionTypes'

export const addIdentityProvider = (identityProvider: object): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        '/organizations/:organizationId/identityproviders',
        ADD_IDP,
        { method: 'POST', body: identityProvider },
        { args: { organizationId: ':organizationId' } }
      )
    )
  }
}

export const updateIdentityProvider = (identityProviderId: string, identityProvider: object): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/identityproviders/${identityProviderId}`,
        UPDATE_IDP,
        { method: 'PUT', body: identityProvider },
        { args: { organizationId: ':organizationId' } }
      )
    )
  }
}

export const deleteIdentityProvider = (identityProviderId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/identityproviders/${identityProviderId}`,
        DELETE_IDP,
        { method: 'DELETE' },
        { args: { identityProviderId, organizationId: ':organizationId' } }
      )
    )
  }
}

export const fetchSamlIdpConfig = (): AppThunk => {
  return dispatch => {
    return dispatch(request(`/organizations/:organizationId/samlidp`, FETCH_SAML_IDP_CONFIG, {}, {}))
  }
}
